const view = (v: string) => () => import(`@/views-new/${v}.vue`)
const docs = () => import('@/docs/index.vue')

const hiddenMeta = {
  sitemap: { ignoreRoute: true },
  blockRobots: true,
  layout: 'beta'
} as const

export const hiddenViews = [
  {
    name: 'docs',
    path: '/beta/docs',
    component: docs,
    meta: { ...hiddenMeta },
  },
  {
    name: 'homeBeta',
    path: '/beta',
    component: view('homepage/index'),
    meta: { ...hiddenMeta },
  },
  {
    name: 'menuBeta',
    path: '/beta/menu',
    component: view('menu/index'),
    meta: { ...hiddenMeta },
  },
  {
    name: 'menuCountryBeta',
    path: '/beta/menu/country',
    component: view('menu/country'),
    meta: { ...hiddenMeta },
  },
  {
    name: 'menuCategoryBeta',
    path: '/beta/menu/:systemName',
    component: view('menu/category'),
    meta: { ...hiddenMeta },
  },
  {
    path: '/beta/profile',
    component: view('profile/layout'),
    meta: { ...hiddenMeta },
    children: [
      {
        name: 'profileBeta',
        path: '',
        component: view('profile/index'),
        meta: { ...hiddenMeta },
      },
    ],
  },
]
